import { Action } from "@ngrx/store";
import { type } from "../../util";

/**
 * Action Types
 */
export const ActionTypes = {
  TEETH_SELECTION_UPDATED: type("[Odontogram] Teeth Selection Updated"),
  TOGGLE_TOOTH: type("[Odontogram] Toggle Tooth"),
  CLEAR_TEETH_SELECTION: type("[Odontogram] Clean Teeth Selection"),
  TOGGLE_QUADRANT_1: type("[Odontogram] Toggle Quadrant 1"),
  TOGGLE_QUADRANT_2: type("[Odontogram] Toggle Quadrant 2"),
  TOGGLE_QUADRANT_3: type("[Odontogram] Toggle Quadrant 3"),
  TOGGLE_QUADRANT_4: type("[Odontogram] Toggle Quadrant 4"),
  RESET_ODONTOGRAM: type("[Odontogram] Reset"),
};

/**
 * Actions
 */
export class TeethSelectionUpdated implements Action {
  type = ActionTypes.TEETH_SELECTION_UPDATED;
  constructor(public payload: number[]) {}
}

export class ToggleToothAction implements Action {
  type = ActionTypes.TOGGLE_TOOTH;
  constructor(public payload: number) {}
}

export class ClearTeethSelectionAction implements Action {
  type = ActionTypes.CLEAR_TEETH_SELECTION;
}

export class ToggleQuadrant1Action implements Action {
  type = ActionTypes.TOGGLE_QUADRANT_1;
}

export class ToggleQuadrant2Action implements Action {
  type = ActionTypes.TOGGLE_QUADRANT_2;
}

export class ToggleQuadrant3Action implements Action {
  type = ActionTypes.TOGGLE_QUADRANT_3;
}

export class ToggleQuadrant4Action implements Action {
  type = ActionTypes.TOGGLE_QUADRANT_4;
}

export class ResetOdontogramAction implements Action {
  type = ActionTypes.RESET_ODONTOGRAM;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | ToggleToothAction
  | ClearTeethSelectionAction
  | ToggleQuadrant1Action
  | ToggleQuadrant2Action
  | ToggleQuadrant3Action
  | ToggleQuadrant4Action
  | ResetOdontogramAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/odontogram/odontogram.actions.ts